import issueImage from '../../../../images/avatar/complaint_note_image.png';

const HaveAnIssue = ({ title, description, onRaiseComplaint }) => {
  return (
    <div className="card have-an-issue-card h-100 mb-0">
      <div className="card-body d-flex align-items-center">
        <div className="issue-image-container">
          <img src={issueImage} alt={title} className="img-fluid" />
        </div>
        <div className="issue-content ms-4">
          <h4 className="mb-2 text-black">{title}</h4>
          <p className="text-muted mb-4">{description}</p>
          <button className="btn btn-primary" onClick={onRaiseComplaint}>
            + Raise Complaint
          </button>
        </div>
      </div>
    </div>
  );
};

export default HaveAnIssue;
